export const GET_STAGE_ALLOCATOR_ACTION = "StageAllocation@GET_STAGE_ALLOCATOR_ACTION";
export const GET_STAGE_ALLOCATOR_REQUEST = "StageAllocation@GET_STAGE_ALLOCATOR_REQUEST";
export const GET_STAGE_ALLOCATOR_SUCCESS = "StageAllocation@GET_STAGE_ALLOCATOR_SUCCESS";
export const GET_STAGE_ALLOCATOR_FAILED = "StageAllocation@GET_STAGE_ALLOCATOR_FAILED";
